<template>
  <div class="tab-container">
    <el-tabs class="fullheight tab-container-root" v-model="currentTabComponent" @tab-click="handlePaneClick" v-if="tabComponentOptions.length > 0">
      <el-tab-pane :name="tabComponent.alias" v-for="(tabComponent, index) in tabComponentOptions" :key="index">
        <span slot="label">
          <el-link :underline="false" :href="genHref(tabComponent.alias)" class="el-linkA">{{ tabComponent.name }}</el-link>
        </span>

        <component v-if="currentTabComponent == tabComponent.alias" v-bind:is="currentTabComponent"></component>
      </el-tab-pane>
    </el-tabs>

    <component v-if="tabComponentOptions.length <= 0" v-bind:is="currentTabComponent"></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// 懒加载组件 只加载当前页面用到的组件
const formManager = () => import('@/views/form/FormManager.vue')
const mobileFormManager = () => import('@/views/form/MobileFormManager.vue')
const formPermissionManager = () => import('@/views/form/FormPermissionManager.vue')
const mobileFormPermissionManager = () => import('@/views/form/MobileFormPermissionManager.vue')
const roleManager = () => import('@/views/uc/RoleManager.vue')
const reportLine = () => import('@/views/uc/ReportLine.vue')
const userListManager = () => import('@/views/uc/UserListManager.vue')
const tenantTypeManager = () => import('@/views/uc/TenantTypeManager.vue')
const tenantParamsManager = () => import('@/views/uc/TenantParamsManager.vue')
const tenantManager = () => import('@/views/uc/TenantManager.vue')
const accountManagement = () => import('@/views/uc/accountManagement.vue')
const tenantInfoManager = () => import('@/views/system/TenantInfoManager.vue')
const customDialogList = () => import('@/views/form/customDialog/CustomDialogList.vue')
const customQueryList = () => import('@/views/form/customquery/CustomQueryList.vue')
const Demension = () => import('@/views/uc/org/Demension.vue')
const fileList = () => import('@/views/file/FileList.vue')
const businessObj = () => import('@/views/form/BusinessObj.vue')
const formTemplateList = () => import('@/views/form/FormTemplateList.vue')
const init_data = () => import('@/views/system/init_data.vue')
const documentManagement = () => import('@/views/system/documentManagement.vue')
const dataTemplateList = () => import('@/views/form/dataTemplate/DataTemplateManager.vue')

const defManager = () => import('@/views/flow/DefManager.vue')
const instanceManager = () => import('@/views/flow/InstanceManager.vue')
const taskManager = () => import('@/views/flow/TaskManager.vue')
const delegationManager = () => import('@/views/flow/DelegationManager.vue')
const agentManager = () => import('@/views/flow/AgentManager.vue')
const secretaryManager = () => import('@/views/flow/SecretaryManager.vue')
const transferManager = () => import('@/views/flow/TransferManager.vue')
const approvalItemList = () => import('@/views/flow/help/ApprovalItemList.vue')
const businessRulesSwitch = () => import('@/views/flow/businessRulesSwitch.vue')
const msgTemplateList = () => import('@/views/flow/help/MsgTemplateList.vue')
const flowAuthManager = () => import('@/views/flow/FlowAuthManager.vue')
const scriptList = () => import('@/views/flow/help/ScriptList.vue')
const conditionScriptList = () => import('@/views/flow/help/ConditionScriptList.vue')
const bpmCommonDefList = () => import('@/views/flow/BpmCommonDefList.vue')

const dataSourceManager = () => import('@/views/meta/DataSourceManager.vue')
const identityManager = () => import('@/views/meta/IdentityManager.vue')

const i18nMessageManager = () => import('@/views/system/i18n/I18nMessageManager.vue')
const i18nMessageTypeManager = () => import('@/views/system/i18n/I18nMessageTypeManager.vue')

const orgManager = () => import('@/views/uc/org/Organization.vue')
const heiOrganization = () => import('@/views/uc/heiorgmanager/HeiOrganization.vue')
const dataDicManager = () => import('@/views/meta/DataDicManager.vue')
const menuManager = () => import('@/views/system/menu/MenuManager.vue')
const methodListManager = () => import('@/views/system/menu/MethodListManager.vue')

const schedulerManager = () => import('@/views/system/SchedulerManager.vue')
const executeJobList = () => import('@/views/system/ExecuteJobList.vue')
const schedulerTriggerList = () => import('@/views/system/SchedulerTriggerList.vue')
const sysTypeTreeManager = () => import('@/views/system/SysTypeTreeManager.vue')
const sysTypeCatManager = () => import('@/views/system/SysTypeCatManager.vue')
const jobManage = () => import('@/views/uc/org/JobManager.vue')
const prgParamManage = () => import('@/views/uc/org/PrgParamManage.vue')
const postManager = () => import('@/views/uc/org/PostManager.vue')
const userParamManager = () => import('@/views/uc/UserParamManager.vue')

const indexLayout = () => import('@/views/portal/IndexLayout.vue')
const indexColumn = () => import('@/views/portal/IndexColumn.vue')

const flowInterfaceCllLog = () => import('@/views/system/log/FlowInterfaceCllLog.vue')
const messageSendLog = () => import('@/views/system/log/MessageSendLog.vue')
const systemLogConfig = () => import('@/views/system/log/SystemLogConfig.vue')
const systemLogList = () => import('@/views/system/log/SystemLogList.vue')
const sysHttpLogs = () => import('@/views/system/log/PortalSysHttpLogsManager.vue')

const layoutDistribution = () => import('@/views/portal/LayoutDistribution.vue')
const defaultLayout = () => import('@/views/portal/DefaultLayout.vue')

const flowChartManager = () => import('@/views/form/FlowChartManager.vue')
const customViewManager = () => import('@/views/form/CustomViewManager.vue')
const customChartManager = () => import('@/views/form/CustomChartManager.vue')
const sysPropertiesManager = () => import('@/views/system/SysPropertiesManager.vue')

const pwdStrategy = () => import('@/views/uc/PwdStrategy.vue')

const viewManageList = () => import('@/views/form/ViewManageList.vue')

const startGenerator = () => import('@/views/system/generator/StartGenerator.vue')
const generatorLog = () => import('@/views/system/generator/GeneratorLog.vue')

const contractPrint = () => import('@/views/form/contractPrint.vue')

const signTemplate = () => import('@/views/form/signTemplate.vue')

const htmbManageList = () => import('@/views/form/htmbManageList.vue')

const costAccountTemplate = () => import('@/views/form/costAccountTemplate.vue')
const oaTaskTemplate = () => import('@/views/form/oaTaskTemplate.vue')
const approvalReportTemplate = () => import('@/views/form/approvalReportTemplate/approvalReportTemplate.vue')

const constructionProcedureTemplate = () => import('@/views/form/constructionProcedureTemplate.vue')

const managementPlanTemplate = () => import('@/views/form/managementPlanTemplate.vue')
const marketTaskTemplate = () => import('@/views/form/marketTaskTemplate.vue')

const package_center = () => import('@/views/form/packageCenterList.vue')

const billing_center_inner = () => import('@/views/form/billingCenterInnerList.vue')
const invoice_record = () => import('@/views/form/invoiceRecordList.vue')
const maintain_center = () => import('@/views/form/maintainCenterList.vue')
import('@/views/form/billingCenterInnerList.vue')
const billingCenterCommon = () => import('@/views/form/billingCenter/billingCenterCommon.vue')

const order_management = () => import('@/views/form/orderManagement.vue')

const payment_record = () => import('@/views/form/paymentRecord.vue')
const OCR_expense_account = () => import('@/views/system/configure/OcrExpenseAccount.vue')
const field_rules = () => import('@/views/system/fieldRules/fieldRules.vue')
const noticeRules = () => import('@/views/system/noticeRules/noticeRules.vue')
const systemAttribute = () => import('@/views/system/systemAttribute.vue')
const customField = () => import('@/views/system/customField.vue')
const system_notice = () => import('@/views/system/systemNotice/systemNotice.vue')
const sysNcConfig = () => import('@/views/system/sysExternalUnite/SysNcConfigManager.vue')
const sysNcTemplate = () => import('@/views/system/sysExternalUnite/SysNcTemplateManager.vue')
const tenantFlowConfigManager = () => import('@/components/tenant/TenantFlowConfigManager.vue')
const flowRouter = () => import('@/components/flow/flowRouterManger.vue')
const demandFeedback = () => import('@/views/system/demandFeedback/demandFeedback.vue')
const ruleConfigManager = () => import('@/components/tenant/RuleConfigManager.vue')
import('@/views/form/billingCenterInnerList.vue')
const bdqx = () => import('@/views/system/formDesign/formDesign.vue')
//水印设置
const watermarkTemplate = () => import('@/views/system/watermark/SettingManager.vue')

import menuApi from '@/api/menu.js'

export default {
  name: 'fe-tabs-component',
  components: {
    businessRulesSwitch,
    formManager,
    mobileFormManager,
    formPermissionManager,
    mobileFormPermissionManager,
    roleManager,
    reportLine,
    menuManager,
    schedulerManager,
    userListManager,
    tenantTypeManager,
    tenantParamsManager,
    tenantManager,
    tenantInfoManager,
    orgManager,
    instanceManager,
    taskManager,
    identityManager,
    executeJobList,
    schedulerTriggerList,
    dataSourceManager,
    dataDicManager,
    i18nMessageManager,
    i18nMessageTypeManager,
    fileList,
    defManager,
    Demension,
    customDialogList,
    customQueryList,
    businessObj,
    bpmCommonDefList,
    sysTypeTreeManager,
    sysTypeCatManager,
    customChartManager,
    delegationManager,
    agentManager,
    secretaryManager,
    transferManager,
    prgParamManage,
    jobManage,
    postManager,
    formTemplateList,
    init_data,
    documentManagement,
    dataTemplateList,
    indexLayout,
    indexColumn,
    msgTemplateList,
    approvalItemList,
    scriptList,
    userParamManager,
    flowAuthManager,
    conditionScriptList,
    methodListManager,
    flowInterfaceCllLog,
    messageSendLog,
    systemLogConfig,
    systemLogList,
    sysHttpLogs,
    layoutDistribution,
    defaultLayout,
    flowChartManager,
    customViewManager,
    heiOrganization,
    sysPropertiesManager,
    startGenerator,
    generatorLog,
    pwdStrategy,
    viewManageList,
    accountManagement,
    htmbManageList,
    constructionProcedureTemplate,
    managementPlanTemplate,
    marketTaskTemplate,
    costAccountTemplate,
    oaTaskTemplate,
    approvalReportTemplate,
    billing_center_inner,
    order_management,
    billingCenterCommon,
    payment_record,
    package_center,
    invoice_record,
    maintain_center,
    OCR_expense_account,
    contractPrint,
    signTemplate,
    sysNcConfig,
    sysNcTemplate,
    tenantFlowConfigManager,
    ruleConfigManager,
    flowRouter,
    field_rules,
    noticeRules,
    system_notice,
    demandFeedback,
    systemAttribute,
    customField,
    bdqx,
    watermarkTemplate
  },
  props: {},
  computed: {
    ...mapGetters({
      tabsStyle: 'styleSetting/tabsStyle'
    }),
    finalTabsStyle: function () {
      // 使用菜单的配置
      if ((this.tabsStyle.tabType == 'menuSetting' || this.tabsStyle.tabType == null) && this.menuTabsStyle) {
        return this.menuTabsStyle
      }

      // 使用默认的
      if (this.tabsStyle.tabType == null || ((this.tabsStyle.tabType == 'menuSetting' || this.tabsStyle.tabType == null) && !this.menuTabsStyle)) {
        return { tabType: '' }
      }
      // 使用全局的配置
      return this.tabsStyle
    }
  },
  data() {
    return {
      tabComponentOptions: [],
      currentTabComponent: '',
      menuTabsStyle: null
    }
  },
  methods: {
    handlePaneClick: function (data) {
      if (data.alias) {
        this.currentTabComponent = data.alias
      }
    },
    genHref(anchor) {
      if (this.$router.mode == 'history') {
        return '#' + anchor
      }
      return '/#' + this.$route.path + '#' + anchor
    },
    activeTab(fullpath) {
      let lastIdx = fullpath.lastIndexOf('#')
      if (lastIdx != -1) {
        let urlAnchor = fullpath.substr(lastIdx + 1)
        this.tabComponentOptions.filter((item) => {
          if (item.alias == urlAnchor) {
            this.currentTabComponent = urlAnchor
          }
        })
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      let routePath = vm.$route.path
      if (routePath) {
        routePath = routePath.replace('/', '')
      }
      menuApi.getMenuByAlias(routePath, (m) => {
        if (m) {
          vm.$emit('menuChange', m)
          if (m.children && m.children.length > 0) {
            vm.tabComponentOptions = m.children
            vm.currentTabComponent = vm.$route.params.active || m.activeTab || vm.tabComponentOptions[0].alias
            vm.activeTab(to.fullPath)
          } else {
            vm.tabComponentOptions = []
            vm.currentTabComponent = m.alias
          }
          if (m.tabsStyle) {
            vm.menuTabsStyle = JSON.parse(m.tabsStyle)
          } else {
            vm.menuTabsStyle = null
          }
        } else {
          // 没有菜单的路由跳转   需要显示TAb名称需要定义tobName参数传递过来
          vm.tabComponentOptions = []
          vm.currentTabComponent = to.name
          vm.$emit('menuChange', { name: to.params.tobName })
        }
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    this.activeTab(to.fullPath)
    next()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/element-variables.scss';
.el-linkA {
  color: #333333;
  font-weight: 400;
}
.tab-container >>> .is-active .el-link {
  // color: $--color-primary;
  color: #155bd4;
  font-weight: 600;
}
.tab-container > div.tab-container-root /deep/ > .el-tabs__content {
  height: calc(100% - 60px);
}
.tab-container {
  //padding: 0 20px;

  /deep/.el-tabs__item {
    padding: 0 20px;
    line-height: 48px;
    height: 48px !important;
  }
  /deep/.el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e0e0e0;
  }
  .el-tab-pane {
    height: 100%;
  }
}
/deep/.eco-table {
  .el-link--primary {
    color: #155bd4;
  }
}
</style>
<style>
.el-dialog__header {
  border-bottom: 1px solid #e0e0e0;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-footer .el-button--primary {
  background-color: #155bd4;
  border-color: #155bd4;
}

.quick-search {
  width: 100% !important;
  max-width: 300px !important;
}
</style>
